import { render, staticRenderFns } from "./AddZarzour.vue?vue&type=template&id=1b0512a2&scoped=true&"
import script from "./AddZarzour.vue?vue&type=script&lang=js&"
export * from "./AddZarzour.vue?vue&type=script&lang=js&"
import style0 from "./AddZarzour.vue?vue&type=style&index=0&id=1b0512a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0512a2",
  null
  
)

export default component.exports